/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import React from 'react';
import { IHosportsCustomSacPageViewProps } from './../../../modules/hosports-custom-sac-page/./hosports-custom-sac-page';
// @ts-ignore
import ReactHtmlParser from 'react-html-parser';
// @ts-ignore
import {CustomSacs} from './../utilities/custom-sacs';
//@ts-ignore
import {GenerateProductAssetUrl} from './../utilities/functions';
//@ts-ignore
import {GeneralAssetUrl} from './../utilities/constants';
// @ts-ignore
import Hero from './../../../baseComponents/hero/./hero';
// @ts-ignore
import PortalModal from './../../../baseComponents/portal-modal/./portal-modal';
// @ts-ignore
import Slider from "./../../../baseComponents/slider/./slider";

interface IState {
  customSacResults?:any;
  yearSelect?:any;
  makeSelect?:any;
  modelSelect?:any;
  modalActive?:any;
  years?:any;
  makes?:any;
  models?:any;
  allModels?:any;
  activeSac?:any;
  customSacList?:any;
  year?:any;
}

/**
 *
 * HosportsSupportPage component
 * @extends {React.PureComponentReact.Component<IHosportsTvPageViewProps>}
 */

class HosportsCustomSacPage extends React.Component<IHosportsCustomSacPageViewProps,IState> {

  public state: IState;

  constructor (props: IHosportsCustomSacPageViewProps) {
      super(props);
      this.state = {
        customSacResults : CustomSacs,
        yearSelect:"All",
        makeSelect:"All",
        modelSelect:"All"
      };
  }

  public componentDidMount = async() => {
    this.setUpFilters();
  }

  public setUpFilters = () => {
    let years:any = [];
		let makes:any = [];
		let models:any = [];
    CustomSacs.map((value:any, index:any)=>{
      value.boats.map((value:any, index:any)=>{
        if (years.indexOf(value.year) == -1 && value.year != "") {
          years.push(value.year);
				}
				if (makes.indexOf(value.make) == -1 && value.make != "") {
          makes.push(value.make);
				}
				if (models.indexOf(value.model) == -1 && value.model != "") {
          models.push(value.model);
				}
      })
      if (index == CustomSacs.length - 1) {
        let yearsSorted:any = years.sort().reverse();
        yearsSorted.unshift('All');
        let makesSorted:any = makes.sort();
        makesSorted.unshift('All');
        let modelsSorted:any = models.sort();
        modelsSorted.unshift('All');
        this.setState({
          years:yearsSorted,
          makes:makesSorted,
          models:modelsSorted,
          allModels:modelsSorted
        })
      }
    })
  }
  public updateFilters = () => {
    let makes:any = [];
		let models:any = [];
    let filteredBoats:any = CustomSacs;
    for (let i = 0; i < filteredBoats.length; i++) {
      for (let x = 0; x < filteredBoats[i].boats.length; x++) {
        let make:any = filteredBoats[i].boats[x].make;
        if(this.state.makeSelect == "All" || this.state.makeSelect == make){
          let model:any = filteredBoats[i].boats[x].model;
          if(model && models.indexOf(model) == -1){
            models.push(model)
          }
        }
      }
      if (i == filteredBoats.length - 1) {
        let makesSorted:any = makes.sort();
        makesSorted.unshift('All');
        let modelsSorted:any = models.sort();
        modelsSorted.unshift('All');
        if(this.state.makeSelect == "All"){
          modelsSorted = this.state.allModels;
        }
        this.setState({
          models:modelsSorted
        })
			}
    }
  }
  public updateMake = (e:any) =>{
    let value:any = e.target.value;
    this.setState({
      makeSelect:value,
    }, () =>{
      this.fillCustomSacs()
      this.updateFilters()
    })
  }
  public updateModel = (e:any) =>{
    let value:any = e.target.value;
    this.setState({
      modelSelect:value,
    }, () =>{
      this.fillCustomSacs()
      this.updateFilters()
    })
  }
  public updateYear = (e:any) =>{
    let value:any = e.target.value;
    this.setState({
      yearSelect:value,
    }, () =>{
      this.fillCustomSacs()
      this.updateFilters()
    })
  }
  public fillCustomSacs = () =>{
    let customSacList:any = [];
    let customSacResults:any = [];
    let year:any = this.state.yearSelect;
		let make:any = this.state.makeSelect;
		let model:any = this.state.modelSelect;
    CustomSacs.map((value:any, index:any)=>{
      let slug:any = value.slug;
      if(value.boats && value.boats.length == 0 && !value.onlyShowUnfiltered){
        customSacList.push(slug);
      } else if(year == 'All' && model == 'All' && make == 'All' && value.onlyShowUnfiltered){
        customSacList.push(slug);
      }
      value.boats.map((value:any, index:any)=>{
        let yearMatch:any = false;
				let makeMatch:any = false;
				let modelMatch:any = false;
				if(year == 'All' || year == value.year || value.year == "" || !year){
          yearMatch = true;
				}
				if(model == 'All' || model == value.model || value.model == "" || !model){
          modelMatch = true;
				}
				if(make == 'All' || make == value.make || value.make == "" || !make){
          makeMatch = true;
				}
				if( yearMatch && modelMatch && makeMatch){
          if(customSacList.indexOf(slug) == -1){
						customSacList.push(slug);
					}
				}
			})
      if (index == CustomSacs.length - 1) {
        this.setState({
          customSacList:customSacList
        })
        customSacList.map((value:any)=>{
          let slug:any = value;
          CustomSacs.map((value:any)=>{
            if(value.slug == slug){
              customSacResults.push(value);
              this.setState({
                customSacResults:customSacResults
              })
            }
          })
        })
			}
    })
  }
  public showModal = (sac:any) =>{
    this.setState({
      modalActive:true,
      activeSac:sac
    })
  }
  public hideModal = () =>{
    this.setState({
      modalActive:false,
      activeSac:null
    })
  }

  public render(): JSX.Element {
    let prodAssetUrl:string = GenerateProductAssetUrl('2023');
    return (
      <div className={'hosports-custom-sac-page'}>
        <div style={{marginTop:"-8%",zIndex:"20",position:"relative"}}>
          <div className="max-width-container white-background shadow">
            <div className="row">
              <div className="small-12 medium-6 black-background centered-text flex" style={{alignItems:'center',justifyContent:'center'}}>
                <div className="full-width centered-text small-padding">
                  <img className="half-width custom-page-icon" style={{maxWidth:"150px", margin:'auto'}} src={GeneralAssetUrl+"fatsac-logo-stamp-white.png"} />
                  <h6 className="white subheading">{'PROUDLY MADE IN THE U.S.A.'}</h6>
                  <h4 className="white">{'Custom & Semi-Custom Series'}</h4>
                  <div className="row">
                    <div className="small-12 medium-12 tiny-padding">
                      <a className="button white-background full-width" href={'/calculator'} style={{color:"#000"}}>{'Price Calculator'}</a>
                    </div>
                    <div className="small-12 medium-12 tiny-padding">
                      <a className="button white-background full-width" download href="https://files-us-prod.cms.commerce.dynamics.com/cms/api/nwtfklkdlc/binary/MAbwI5" style={{color:"#000"}}>{'Download Order Form'}</a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="small-12 medium-6 white-background medium-padding">
                <div className="tiny-padding">
                  <h3>{'Choose Your Boat'}</h3>
                </div>
                {this.state.years &&
                  <div>
                    <div className="tiny-padding">
                      <h6>{'Year'}</h6>
                      <select value={this.state.yearSelect} onChange={this.updateYear} className="full-width custom-sac-select">
                        {this.state.years.map((data:any)=>{
                          return(
                            <option value={data}>{data}</option>
                          )
                        })}
                      </select>
                    </div>
                    <div className="tiny-padding">
                      <h6>{'Make'}</h6>
                      <select value={this.state.makeSelect} onChange={this.updateMake} className="full-width custom-sac-select">
                        {this.state.makes.map((data:any)=>{
                          return(
                            <option value={data}>{data}</option>
                          )
                        })}
                      </select>
                    </div>
                    <div className="tiny-padding">
                      <h6>{'Model'}</h6>
                      <select value={this.state.modelSelect} onChange={this.updateModel} className="full-width custom-sac-select">
                        {this.state.models.map((data:any)=>{
                          return(
                            <option value={data}>{data}</option>
                          )
                        })}
                      </select>
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
        <div className="light-grey-background">
          <div className="section-padding">
            {this.state.customSacResults.map((value:any)=>{
              return(
                <div className="max-width-container" style={{marginTop:"10px"}}>
                  <div className="row tiny-padding white-background shadow">
                    <div className="small-12 medium-3 tiny-padding" onClick={()=> this.showModal(value)}>
                      <img className="full-width" src={prodAssetUrl+value.slug+".jpg"} onError={(e:any)=>{if(e && e.target){ if(e.target.src){e.target.src=GeneralAssetUrl+"/coming-soon.jpg"}}}}/>
                    </div>
                    <div className="small-12 medium-9 tiny-padding">
                      <h5 className="tiny-bottom-margin">{value.title}</h5>
                      <i className="subheading">{'PN# ' + value.partNumber}</i>
                      <h6 className="subheading">{value.price !="" && '$'}{value.price}</h6>
                      {(value.partNumber == "O8005") && <h6 style={{marginTop:"20px"}}><a  target="_blank" href="pdf/retrokit-installation-instructions.pdf">{'Installation Instructions'}</a></h6>}
                      {(value.partNumber == "C1326") && <h6 style={{marginTop:"20px"}}><a  target="_blank" href="pdf/instruction-yamaha.pdf">{'Installation Instructions'}</a></h6>}
                      {(value.partNumber == "C1304") && <h6 style={{marginTop:"20px"}}><a  target="_blank" href="pdf/instruction-yamaha.pdf">{'Installation Instructions'}</a></h6>}
                      {(value.partNumber == "C1062" || value.partNumber == "C1046" || value.partNumber == "C1039") && <h6 style={{marginTop:"20px"}}><a  target="_blank" href="pdf/instruction-yamaha.pdf">{'Installation Instructions'}</a></h6>}
                      {(value.partNumber == "558032" || value.partNumber == "W714" || value.partNumber == "W717") && <h6 style={{marginTop:"20px"}}><a  target="_blank" href="pdf/instruction-x2-mastercraft.pdf">{'Installation Instructions'}</a></h6>}
                      {value.description && <p className="subheading">{ReactHtmlParser(value.description)}</p>}
                      <div className="boats">
                        {value.boats &&
                          <div>
                            {value.boats.map((value:any)=>{
                              return(
                                <div
                                  className="subheading light-grey-background medium-grey global-radius"
                                  style={{cursor:"default",display:"inline-block",padding:"5px",margin:"5px",fontSize:"14px"}}>
                                  {value.year+' '+value.make+' '+value.model}
                                </div>
                              )
                            })}
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              )
            })}
          </div>
          {this.state.modalActive &&
            <PortalModal
              modalHidden={this.hideModal}
              modalActive={this.state.modalActive}
              content={
                <div className="tagged-image-full-screen-container active full-height full-width" style={{display:"flex", alignItems:'center',justifyContent:'center', backgroundColor:"rgba(0,0,0,.5)"}}>
                  <div style={{width:"100%",maxWidth:1000}}>
                    {this.state.activeSac && this.state.activeSac.extraImages
                      ?
                      <Slider>
                        {this.state.activeSac.extraImages && this.state.activeSac.extraImages.map((image:any)=>{
                          return(
                            <div>
                              <img className="background-image-contain full-width white-background" src="/images/rectangle.png" style={{backgroundImage:'url('+image+')'}} onError={(e:any)=>{if(e && e.target){ e.target.src=GeneralAssetUrl+"coming-soon.jpg"}}} />
                            </div>
                          )
                        })}
                      </Slider>
                      :
                      <img className="full-width" src={prodAssetUrl+ this.state.activeSac.slug + ".jpg"} onError={(e:any)=>{if(e && e.target){ e.target.src=GeneralAssetUrl+"coming-soon.jpg"}}} />
                    }
                  </div>
                </div>
              }
            />
          }
        </div>
      </div>
    );
  }
}

export default HosportsCustomSacPage;
